module.exports = __webpack_public_path__ + "static/media/leaves.80be6f31.mp3";